
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"412","height":"2012","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M561.321 2015.03c-47.72-91.46-21.842-163.42-1.058-221.25 19.255-53.55 28.264-83.48 5.951-126.01-22.316-42.51-52.067-52.13-107.111-66.75-59.406-15.77-133.939-34.35-180.567-125.35-47.215-89.96-21.334-161.93-.54-219.75 19.264-53.55 28.27-83.47 5.962-125.98-22.33-42.54-52.092-52.12-107.644-65.76-58.858-16.72-132.802-36.35-180.007-126.298-47.207-89.953-21.71-161.257-.537-219.731 19.26-53.546 28.27-83.474 5.962-125.982-22.317-42.519-52.067-52.115-107.087-66.724-59.412-15.762-133.369-35.387-180.565-125.334-47.2-89.943-21.322-161.906-.52-219.714 19.261-53.546 28.704-83.218 5.959-125.978L-177.085.223c47.193 89.931 21.315 161.894.514 219.704-19.262 53.545-28.268 83.468-5.969 125.971 22.338 42.551 52.098 52.125 107.09 66.719 59.415 15.776 133.373 35.403 180.564 125.334 47.207 89.953 21.331 161.911-.011 220.679-18.716 52.603-28.118 83.211-4.493 125.573 21.417 42.012 51.175 51.592 106.167 66.184 59.428 15.779 133.362 35.399 180.564 125.333 47.206 89.96 21.331 161.91 1.285 220.17-20.012 53.11-28.752 83.2-6.705 125.56 22.316 42.54 52.076 52.14 107.11 66.75 59.412 15.76 133.358 35.41 180.304 125.83 47.476 89.49 21.598 161.45.814 219.28-19.254 53.55-28.264 83.48-5.951 126.01l-102.877 55.71z","fill":"#F6E94A"}})])
          )
        }
      }
    